import React, { useState, useEffect } from 'react';
import { MainContainer, MainHeaderContainer } from 'layouts/components';
import { ToastNotification, Loading } from 'carbon-components-react';
import DisplayUsers from './components/DisplayUsers';
import { SearchedUser } from './types';
import UserDetails from './components/UserDetails';
import ApplyFilterForm from './components/forms/ApplyFilterForm';
import ReactDOM from 'react-dom';
import { searchUsers, searchUser } from 'services/searchUsers.service';
import { APP } from 'app/AppRoutes';
import dayjs from 'dayjs';

import { toLocalDateTimeFormat } from 'utilities/helper.util';
const initialValues = {
  email: '',
  firstName: '',
  lastName: '',
  organisation: '',
  utilityId: '',
  phone: ''
};
const initialRoleFilterValue = {
  id: '0',
  text: 'Choose a role...'
};
const initialLastLoginFilterValue = {
  id: '4',
  text: 'Today'
};
const SearchUsers: React.FC<any> = () => {
  const [users, setUsers] = useState<Array<SearchedUser> | null>(null);
  const [filteredUsers, setFilteredUsers] = useState<
    Array<SearchedUser> | undefined
  >(undefined);
  const [user, setUser] = useState<any>(null); // for one user . TODO use different type
  const [isFormModalOpen, setIsFormModalOpen] = useState<boolean>(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState<boolean>(false);
  const initialPaginationProps = {
    offset: 0,
    limit: 10
  };
  const [apiInvokers, setApiInvokers] = useState<any>({
    filter: `lastLoggedInAfter:${dayjs().startOf('day').toISOString()}`,
    paginationProps: initialPaginationProps
  });
  const [apiError, setApiError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filterValues, setFilterValues] = useState({ ...initialValues });
  const [roleFilterValue, setRoleFilterValue] = useState(
    initialRoleFilterValue
  );
  const [lastLoginFilterValue, setlastLoginFilterValue] = useState(
    initialLastLoginFilterValue
  );
  const [currentPaginationStatus, setcurrentPaginationStatus] = useState({
    count: 0,
    currentPage: 0,
    totalPages: 0
  });
  const [sortOrder, setSortOrder] = useState<any>({
    sortedBy: 'email',
    sortedOrder: 'A'
  });

  const handleOpenCloseFormFilter = () => setIsFormModalOpen(!isFormModalOpen);

  const handleSetUserId = async ({ userId }: { userId: string }) => {
    try {
      const response = await searchUser({ userId });
      setUser({
        id: response.id,
        firstName: response.firstName,
        email: response.email,
        lastName: response.lastName,
        companyName: response.companyName,
        phoneNumber: response.phoneNumber,
        address: response.Address,
        createdAt: toLocalDateTimeFormat(response.createdAt),
        lastLoggedInAt: toLocalDateTimeFormat(response.lastLoggedInAt),
        organisations: response.Organisations.map((item: any) => ({
          id: item.id,
          name: item.name,
          utilityId: item.utilityId
        })),
        alternateEmail: response.alternateEmail || 'Not set',
        role: response.role
      });
      setIsDetailsModalOpen(true);
    } catch (err) {
      setApiError('Error fetching users details');
    }
  };
  const handleSetFilter = (filter: any, filterValues: any) => {
    setApiInvokers({
      paginationProps: initialPaginationProps,
      filter
    });
    setIsFormModalOpen(false);
    setFilterValues(filterValues);
  };

  const handleResetFilter = () => {
    setApiInvokers({
      ...apiInvokers,
      filter: `lastLoggedInAfter:${dayjs().startOf('day').toISOString()}`
    });
    setFilterValues({ ...initialValues });
    setRoleFilterValue(initialRoleFilterValue);
    setlastLoginFilterValue(initialLastLoginFilterValue);
  };
  const handleFetchNextPage = (props: any) => {
    const { page, pageSize } = props;
    setApiInvokers({
      ...apiInvokers,
      paginationProps: { offset: page * pageSize - pageSize, limit: pageSize }
    });
  };
  const handleChangeSearchBy = (searchText: any) => {
    if (searchText?.length < 3) {
      setFilteredUsers(undefined);
    } else {
      const filteredUsersLocal = users?.filter((user: any) => {
        return (
          user.email?.toUpperCase().includes(searchText.toUpperCase()) ||
          user.firstName?.toUpperCase().includes(searchText.toUpperCase()) ||
          user.lastName?.toUpperCase().includes(searchText.toUpperCase()) ||
          user.roles?.find((r: string) =>
            r.toUpperCase().includes(searchText.toUpperCase())
          )
        );
      });
      setFilteredUsers(filteredUsersLocal);
    }
  };
  useEffect(() => {
    setIsLoading(true);
    const fetchApi = async () => {
      const params: any = {
        fields: '*',
        order: `${sortOrder.sortedOrder === 'A' ? '' : '-'}${
          sortOrder.sortedBy
        }`,
        include: 'Organisation',
        limit: apiInvokers.paginationProps.limit,
        offset: apiInvokers.paginationProps.offset,
        filter: apiInvokers.filter
      };
      try {
        const response: any = await searchUsers({
          params
        });

        const users: Array<any> = response.Users.map((user: any) => {
          const roles: string[] = [];
          user?.Organisations?.forEach((o: any) => {
            if (
              o.OrganisationUser.role &&
              !roles.includes(o.OrganisationUser.role)
            ) {
              roles.push(o.OrganisationUser.role);
            }
          });
          roles.push(user.role);
          roles.sort();
          return {
            id: user.id.toString(),
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            roles,
            lastLoggedInAt:
              (user.lastLoggedInAt &&
                toLocalDateTimeFormat(user.lastLoggedInAt)) ||
              'Never'
          };
        });
        setUsers(users);
        setcurrentPaginationStatus({
          count: response.Info.count,
          currentPage:
            response.Info.offset / apiInvokers.paginationProps.limit + 1,
          totalPages: response.Info.count / apiInvokers.paginationProps.limit
        });
      } catch (err) {
        setApiError('Error fetching users');
        setUsers(null);
      } finally {
        setIsLoading(false);
      }
    };
    fetchApi();
  }, [apiInvokers, sortOrder]);

  const pageInfo = {
    currentPage: currentPaginationStatus.currentPage,
    pageSize: apiInvokers.paginationProps.limit,
    totalItems: currentPaginationStatus.count,
    handleFetchNextPage
  };
  return (
    <>
      {isFormModalOpen &&
        ReactDOM.createPortal(
          <ApplyFilterForm
            handleSetFilter={handleSetFilter}
            handleResetFilter={handleResetFilter}
            filterValues={filterValues}
            handleSetLastLoginFilter={setlastLoginFilterValue}
            handleSetRoleFilter={setRoleFilterValue}
            handleOpenCloseFilter={handleOpenCloseFormFilter}
            roleFilterValue={roleFilterValue}
            lastLoginFilterValue={lastLoginFilterValue}
          />,
          document.querySelector(`#${APP}`) || document.body
        )}
      {isDetailsModalOpen &&
        ReactDOM.createPortal(
          <UserDetails
            user={user}
            setIsDetailsModalOpen={setIsDetailsModalOpen}
          />,
          document.body
        )}
      <div className="search-users-main-container container--wrapper">
        <MainHeaderContainer enableHeaderGlobalBar />
        <MainContainer>
          <div className="search-users-body-wrapper">
            <section className="search-users-header--wrapper">
              {apiError && (
                <ToastNotification
                  lowContrast
                  caption=""
                  iconDescription="Error fetching api"
                  title={apiError}
                  onCloseButtonClick={() => setApiError(null)}
                />
              )}
              <h1 className="main-heading">All users</h1>
            </section>
            <section className="search-users-content--wrapper">
              <DisplayUsers
                responseUsers={filteredUsers || users}
                pageInfo={pageInfo}
                setApiError={() => {}}
                handleOpenCloseFilter={handleOpenCloseFormFilter}
                handleSetUserId={handleSetUserId}
                handleChangeSearchBy={handleChangeSearchBy}
                sortOrder={sortOrder}
                setSortOrder={setSortOrder}
              />
            </section>
          </div>
        </MainContainer>
        {isLoading && <Loading withOverlay={true} />}
      </div>
    </>
  );
};
SearchUsers.displayName = 'SearchUsers';
export default SearchUsers;
